import { useContext } from 'react';
import { CentralProviderContext } from '../centralProviderContext/CentralProviderContext';
export function useGetSelectedLocationAccountNumber() {
    var selectedGrantLocation = useContext(CentralProviderContext).selectedGrantLocation;
    if (!selectedGrantLocation)
        return null;
    // support for the new location format [Core Profile]
    return selectedGrantLocation.customer_number || selectedGrantLocation.accountNumber.toString();
}
//# sourceMappingURL=useGetSelectedLocationAccountNumber.js.map